import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CasUserContext } from "../../services/casUserContext";
import { ProductoTerminadoDTO } from "../../interfaces/ProductoTerminadoDTO";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from 'yup';
import { Alert, Box, Button, FormControl, Grid, InputLabel, MenuItem, Select, SelectChangeEvent, TextField} from "@mui/material";
import { TipoProductoDTO } from "../../interfaces/TipoProductoDTO";
import {MdAssignmentReturn} from 'react-icons/md';
import { RiSave3Fill } from 'react-icons/ri';
import CatalogService from "../../services/CatalogService";
import ProductoService from "../../services/ProductoService";
import ProyectoService from "../../services/ProyectoService";
import AlertService from "../../services/AlertService";
import { Container } from "reactstrap";
import { TblProductoProdTermin, setProductoTerminado } from "../../interfaces/TblProductoProdTermin";
import { format, parse } from "date-fns";

const validationSchema = Yup.object().shape({
    idproducto: Yup.string().notOneOf(['0',''],'No puede ser ninguno'),
    doi: Yup.string().required('El doi es requerido.'),
    url: Yup.string().required('El url es requerido.'),
});

const catalogService = new CatalogService();
const productoService = new ProductoService();
const alertaService = new AlertService();

interface Props{
    productoterminado: ProductoTerminadoDTO,
    defaultTipo: number,
    defaultCategoria?: number,
    idProducto:number,
    categoriasAvalible: Array<number>,
    tiposAvalible: Array<number>,
    onResponse?: (dataRespuesta: TblProductoProdTermin) => void // Función para pasar la respuesta al padre
}

export default function OldProductoForm(parametro:Props) {
    let history = useNavigate()
    const casUserContext = useContext(CasUserContext);
    const token = casUserContext.token;
    //#region variables
    const [tipoProductos,setTipoProductos] = useState<Array<TipoProductoDTO>>([])
    const [responseData,setResponseData] = useState<TblProductoProdTermin>();
    const [ready,setReady] = useState(false);
    const [saving,setSaving] = useState(false);
    //#endregion
    //#region Funciones
    const save = async (values:any) =>{
        setSaving(true);
        let obj:TblProductoProdTermin = setProductoTerminado(parametro.productoterminado.producto);
        //console.log(values);
        const fechaNula = new Date(1, 0, 1);
        const fechaHoy = new Date(); // Obtiene la fecha y hora actual
        obj.sjr = parametro.productoterminado.producto.sjr.toString();
        obj.doi = values.doi;
        obj.url = values.url;        
        //Control fechas
        obj.fechapublicacion = obj.fechapublicacion.length > 0 ? format(parse(obj.fechapublicacion, "dd/MM/yyyy H:mm:ss", new Date()), "yyyy-MM-dd") : format(fechaNula,'yyyy-MM-dd');              
        obj.fvencimiento = obj.fvencimiento.length > 0 ? format(parse(obj.fvencimiento, "dd/MM/yyyy H:mm:ss", new Date()), "yyyy-MM-dd") : format(fechaNula,'yyyy-MM-dd');
        obj.fevento = obj.fevento.length > 0 ? format(parse(obj.fevento, "dd/MM/yyyy H:mm:ss", new Date()), "yyyy-MM-dd") : format(fechaNula,'yyyy-MM-dd');
        obj.ultimoCambio = format(fechaHoy,"yyyy-MM-dd'T'HH:mm:ss.SSSXXX");        
        //console.log(obj);
        const resp = await productoService.UpdateTblProductoTerminadoContext(obj,token);
        alertaService.hideLoading();
        if(resp.status.isSuccessfully) {
            setResponseData(resp.data);
            setSaving(false);
            if (parametro.onResponse) {
                parametro.onResponse(resp.data);
            } else {
                console.error('La función onResponse no está definida.');
            }
        }else{
            setSaving(false);
            alertaService.alertaAdvertenciaList("Alerta",resp.status.messages);
        }
    }
    const goToNavigation = (site:string) =>{
        history(site)
    }
    const fetchData = async () =>{
        try{
            await catalogService.obtenerCatalogoTipoProductoInactivo()
              .then((data) => {
                 setTipoProductos(data.listData)
                 //console.log(data.listData)
              })
              .catch((error) => console.error(error))
            }catch(error){
                console.error('Error:',error);
                alertaService.alertaAdvertencia('Alerta','Ocurrio un error al momento de cargar la información.');
            }
            setReady(true);
    }
    //#endregion
    //#region Effects
    useEffect(() => { 
          fetchData();
    },[]);
    //#endregion
    return(
        <Container>
        {ready ?
        <Formik 
        initialValues={{
            idproductoterminado: parametro.productoterminado.producto.iddecinvproyectoprodtermin,
            titulo: parametro.productoterminado.producto.titulo,
            tipo: parametro.productoterminado.producto.iddecinvtipoproductoesperado,
            doi: parametro.productoterminado.producto.doi,
            url: parametro.productoterminado.producto.url 
        }}
        validationSchema={validationSchema}
        onSubmit={save}        
        >
           {({isValid,setFieldValue,values,errors,touched,handleSubmit,handleChange,handleBlur}) => (
            <Form onSubmit={handleSubmit}>                  
            <Grid className='siempre' container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
            <Field 
                as={TextField}
                name="titulo"
                label="Titulo Producto"
                variant="outlined" 
                sx={{ m: 1, width: '100%' }}                
                type="text" 
                values={values.titulo}
                disabled          
            />
            <ErrorMessage name='titulo' className='errorMessage' component="div">
                            {(error) => (
                                <Alert severity="error">
                                {error}
                                </Alert>
                            )}
            </ErrorMessage>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
            <FormControl sx={{ m: 1 }} fullWidth error={Boolean(errors.tipo && touched.tipo)} >
                <InputLabel htmlFor="select-tipo">Producto</InputLabel>
                <Select
                    labelId="select-tipo"
                    label='Producto'
                    variant="outlined"                
                    name="tipo"
                    disabled
                    value={values.tipo}
                    >
                    {/* Ordenar por nombre */}
                    {tipoProductos.sort((a, b) => {
                        if (a.nombreProducto < b.nombreProducto) return -1;
                        if (a.nombreProducto > b.nombreProducto) return 1;
                        return 0;
                    }).map((tipoP) => (
                        <MenuItem key={tipoP.idProducto} value={tipoP.idProducto} >
                        {tipoP.nombreProducto}                    
                        </MenuItem>
                    ))}
                </Select>
                <ErrorMessage name='tipo' className='errorMessage' component="div"/>
            </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
            <Field 
                as={TextField}
                name="url"
                label="Url Publicación: "
                variant="outlined" 
                sx={{ m: 1, width: '100%' }}                
                type="text" 
                values={values.url}
                onChange={handleChange}
                onBlur={handleBlur}         
            />
            <ErrorMessage name='url' className='errorMessage' component="div">
                            {(error) => (
                                <Alert severity="error">
                                {error}
                                </Alert>
                            )}
            </ErrorMessage>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
            <Field 
                as={TextField}
                name="doi"
                label="Doi: "
                variant="outlined" 
                sx={{ m: 1, width: '100%' }}                
                type="text" 
                values={values.doi}
                onChange={handleChange}
                onBlur={handleBlur}         
            />
            <ErrorMessage name='doi' className='errorMessage' component="div">
                            {(error) => (
                                <Alert severity="error">
                                {error}
                                </Alert>
                            )}
            </ErrorMessage>
            </Grid>
            </Grid>
            <br />            
            <Box sx={{'& .MuiTextField-root': { m: 1 }, }}>
            <Grid className='siempre' container spacing={2}>
                <Grid item xs={12} sm={12} md={4} lg={4}>
                <Button 
                  color="error"
                  variant="contained"      
                  onClick={() => goToNavigation('/Producto/MisProductos')}                               
                  endIcon={<MdAssignmentReturn />} >
                  Regresar
                </Button>
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4}>
                <Button 
                  type='submit'
                  disabled={saving} 
                  variant="contained"                                     
                  endIcon={<RiSave3Fill />} >
                  Guardar
                </Button>
                </Grid>                
                <Grid item xs={12} sm={12} md={4} lg={4}>
                </Grid> 
            </Grid> 
            </Box>  
           </Form>
           )}           
        </Formik>
        :<></>}
        </Container>
    );
}